import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import APIManager from 'modules/common/apiManager';
import {
  ModalTrigger,
  Pagination,
  ButtonCommonTheme,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper
} from 'modules/theme';
import { ModalForm, ModalFormContainer } from '../../../../theme/theme1/common/styles/main';

class RcsProviderAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `RCS Provider`;
    this.moduleUrl = `setting/rbmConfig`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
  }
  setData(editData = '') {
    editData = editData || {};
    this.state = {
      name: editData.name || '',
      prefix: editData.prefix || '',
      secretFile: editData.secretFile || ''
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  handleSelect(selectedOption, name) {
    this.setState({ [name]: selectedOption ? selectedOption.value : null });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      Alert.success(`${data.message}`);
      this.setData();
      this.props.closeModal(true);
    } else {
      Alert.error(`${data.message}`);
    }
  }

  saveData(e) {
    e.preventDefault();
    let _this = this;
	let {name, prefix} = this.state;
	name = name.trim();
  prefix = prefix.trim();
	if (!(name && prefix)) return Alert.error('Please enter valid values');
    let formData = new FormData();
    formData.append('name', name);
    formData.append('prefix', prefix);
    formData.append('file', this.state.secretFile);

    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostForm(
        `${this.moduleUrl}/${this.props.editData._id}`,
        formData,
        data => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.setData();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} updated successfully`)
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: this.props.editData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostForm(
        `${this.moduleUrl}`,
        formData,
        data => {
          _this.setData();
          _this.props.update();
          _this.props.closeModal(true);
          Alert.success(`${this.moduleName} created successfully`);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  render() {
    const { modalType } = this.props;
    return (
      <ModalForm onSubmit={e => this.saveData(e)}>
        <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('name', {
                placeholder: "Name",
                autoFocus: true,
                required: true,
                id: 'name',
                maxLength: 25,
                value: this.state.name,
                onChange: e => {
                  this.setState({ name: e.target.value });
                }
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('prefix', {
                placeholder: 'Prefix',
                autoFocus: false,
                required: true,
                id: 'prefix',
                value: this.state.prefix,
                onChange: e => {
                  this.setState({ prefix: e.target.value });
                }
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn className="w-100">
              {this.renderFormGroup('Secret file', {
                id: 'file',
                autoFocus: false,
                componentClass: 'file',
                type: 'file',
                required:true,
                accept: '.json',
                selectedFile: this.state.secretFile,
                onChange: e => {
                  if (e.target.files && e.target.files[0]) {
                    this.setState({ secretFile: e.target.files[0] });
                  } else {
                    this.setState({ secretFile: null });
                  }
                },
              })}
            </FormColumn>
          </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type='greyModalBtn'
            onClick={() => this.props.closeModal()}
          >
            Cancel
          </ButtonCommonTheme>
          <ButtonCommonTheme
            type='blueModalBtn'
            btnType="submit"
          >
            {this.props.editData && this.props.editData._id ? 'Update' : 'Add'}
          </ButtonCommonTheme>
        </ModalFooter>
      </ModalForm>
    );
  }
}

RcsProviderAddEdit.propTypes = {
  group: PropTypes.array
};

RcsProviderAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired
};

export default RcsProviderAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/RcsProvider/components/RcsProviderAddEdit.js